import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { generalService } from '../../../services/general.service';
import { MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { DataSourceGrid } from '../../../utils/data-source-grid.component';
import { DataService } from '../../../utils/data.service';
import{ BalanzaComprobacionXMLComponent } from '../consultar/archivoXML/balanzaComprobacion-generarXML'

@Component({
  selector: 'BalanzaComprobacion-consultar',
  templateUrl: './balanzaComprobacion-consultar.component.html',
  styleUrls: ['./balanzaComprobacion-consultar.component.scss'],
  providers: [generalService]
})

export class BalanzaComprobacionConsultarComponent implements OnInit {
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource: DataSourceGrid | MatTableDataSource<any> | null = null;
  myForm: FormGroup;
  fechaInicioOptions: { id: number, name: string }[] = [];
  fechaFinOptions: { id: number, name: string }[] = [];
  displayedColumns = [];
  list_balanza =[
    {balanza_ID: 0, balnza_NAME: 'Balanza normal'},
    {balanza_ID: 1, balnza_NAME: 'Balanza electrónica'}
  ];
  public list_Nivel: any[] = [];
  public level = 0;
  public rfcCompany = '';
  public dataBalanzaComprobacion: any[] = [];
  public filteredDataNivel: any[] = [];
  public list_XML: any[] = [];

  public totalSaldoInicial_RANGE_Type = 0;
  public totalSaldoFinal_RANGE_Type = 0;
  public totalAbonol_RANGE_TYPE = 0;
  public totalCargo_RANGE_TYPE = 0;

  public totalSaldoInicial_ACCOUNT_SAT_PARENT = 0;
  public totalSaldoFinal_ACCOUNT_SAT_PARENT = 0;
  public totalAbonol_ACCOUNT_SAT_PARENT = 0;
  public totalCargo_ACCOUNT_SAT_PARENT = 0;

  constructor( public dialog: MatDialog,
    private formBuilder: FormBuilder,private _generalService: generalService,public dataService: DataService,) {
    this.generateFechaInicioOptions();
  }

  ngOnInit() {
    this.buildForm();
    this.getDataFilters();
    setTimeout(() => {
      this.consultarBalanzaComprobacion();
    }, 600); 
  }
  buildForm(){
    const startMonthYear = this.fechaInicioOptions[0].id; // primer elemnto de la lista
  
    this.myForm = this.formBuilder.group({
      nivelForm: ['', Validators.required],
      fechaInicio: [startMonthYear, Validators.required],
      fechaFin: [startMonthYear, Validators.required],
      balanzaForm: [0, Validators.required],
    });
  
    this.myForm.get('fechaInicio').valueChanges.subscribe(() => {
      this.updateFechaFinOptions();
    });
  
    // Actualizar fecha
    this.updateFechaFinOptions();
  }

  getDataFilters() {
    this.list_Nivel= [];
    let metodo = 'BalanzaComprobacion/getLevel';
    const params = { 
        loacs: sessionStorage.getItem('acslo'),
    };

    this._generalService.metodoCallParams(params, metodo, true).subscribe(
      result => {
        const tableResult = JSON.parse(result);
        this.level = tableResult.Table[0]['LEVEL'];
        for(let i = this.level; i >= 1; i--){
          this.list_Nivel.push({
            nivel: i,
            NAME: i
          });
        }
        this.myForm.get('nivelForm').setValue(this.list_Nivel[0]['nivel']);
      },
      error => {  console.log(<any>error);  }
    );
    
  }

  generateFechaInicioOptions() {
    const currentDate = moment();
    for (let i = 0; i < 12; i++) {
      const date = currentDate.clone().subtract(i, 'months');
      this.fechaInicioOptions.push({
        id: parseInt(date.format('YYYYMM'), 10),
        name: date.format('MMMM YYYY')
      });
    }
  }

 
  updateFechaFinOptions() {
    const startMonthYear = this.myForm.get('fechaInicio').value;
    const startYear = Math.floor(startMonthYear / 100);
    const startMonth = startMonthYear % 100;
    const startDate = moment({ year: startYear, month: startMonth - 1 });
  
    // Obtener el último mes del mismo año que la fecha de inicio
    const endDate = moment({ year: startYear, month: 11 });
    
    this.fechaFinOptions = [];
  
    while (startDate.isBefore(endDate) || startDate.isSame(endDate, 'month')) {
      this.fechaFinOptions.push({
        id: parseInt(startDate.format('YYYYMM'), 10),
        name: startDate.format('MMMM YYYY')
      });
      startDate.add(1, 'month');
    }
  
    const currentEndDate = this.fechaFinOptions[0].id;
    this.myForm.get('fechaFin').setValue(currentEndDate);
  }
  
  consultarBalanzaComprobacion(){
    this.dataBalanzaComprobacion = [];
    this.filteredDataNivel = [];
    let balanza = '';
    let anio;
    this.totalSaldoInicial_RANGE_Type = 0;
    this.totalAbonol_RANGE_TYPE = 0;
    this.totalCargo_RANGE_TYPE = 0;
    this.totalSaldoFinal_RANGE_Type = 0;
    this.totalSaldoInicial_ACCOUNT_SAT_PARENT = 0;
    this.totalSaldoFinal_ACCOUNT_SAT_PARENT= 0;
    this.totalAbonol_ACCOUNT_SAT_PARENT = 0;
    this.totalCargo_ACCOUNT_SAT_PARENT = 0;

    const fechaInicio = String(this.myForm.get('fechaInicio').value);
    const numeromesInicio = fechaInicio.slice(-2); // Obtiene el último carácter
    const fechaFin = String(this.myForm.get('fechaFin').value);
    const numeromesFin = fechaFin.slice(-2); // Obtiene el último carácter
    balanza = this.myForm.controls['balanzaForm'].value;
    let nivel = this.myForm.controls['nivelForm'].value;
    anio = parseInt(String(this.myForm.get('fechaInicio').value).substring(2, 4), 10);
    const params = { 
      NIVEL: nivel,
      BALANZA: balanza,
      fechaInicio: numeromesInicio,
      fechaFin: numeromesFin,
      anio: anio,
      loacs: sessionStorage.getItem('acslo')
    };

    this._generalService.metodoCallParams(params, 'BalanzaComprobacion/consultBalanzaComprobacion', true).subscribe(
      (result) => {
        const tableResult = JSON.parse(result);
        if (tableResult.Table != undefined || tableResult.Table != null) {
          this.dataBalanzaComprobacion = tableResult.Table;

          if (balanza == '0') {
            const structuredData = this.structureData(this.dataBalanzaComprobacion);

            // Ordenar elementos con RANGE_ACCOUNT_ID igual a 3 para que se muestren al final
            const sortedData = structuredData.filter(item => item.RANGE_ACCOUNT_ID !== 3).concat(structuredData.filter(item => item.RANGE_ACCOUNT_ID === 3));

            for (const key of structuredData) {
              if (key.RANGE_TYPE_ID_index !== undefined) {
                this.totalSaldoInicial_RANGE_Type += key.TotalSaldoInicial_RANGE_TYPE || 0;
                this.totalSaldoFinal_RANGE_Type += key.TotalSaldoFinal_RANGE_TYPE || 0;
                this.totalAbonol_RANGE_TYPE += key.TotalAbono || 0;
                this.totalCargo_RANGE_TYPE += key.TotalCargo || 0;
              }
            }

            this.filteredDataNivel = sortedData.filter(item => item.NIVEL <= nivel);

            //console.log( this.filteredDataNivel)
            


            // Mueve el elemento con type 'TOTAL' al final
            const moverTotalUltimafila = (array: any[]) => {
              // Encuentra el índice del elemento con type 'TOTAL'
              const totalIndex = array.findIndex(item => item.type === 'TOTAL');
              if (totalIndex !== -1) {  //asegurarse de que el elemento con type === 'TOTAL' existe
                // Elimina el elemento de su posición original
                const [totalElement] = array.splice(totalIndex, 1);
                // Agrega el elemento al final del array
                array.push(totalElement);
              }
              return array;
            };

            // Actualiza this.filteredDataNivel
            this.filteredDataNivel = moverTotalUltimafila(this.filteredDataNivel);

            this.dataSource = new MatTableDataSource(this.filteredDataNivel);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;

          } else {
            const structuredData2 = this.structureData2(this.dataBalanzaComprobacion);

              // Función para agrupar y sumar valores
              const agruparYSumar = (data: any[]): any[] => {
                const resultado: { [key: string]: any } = {};

                data.forEach(item => {
                  if (!resultado[item.ACCOUNT_SAT_ID]) {
                    resultado[item.ACCOUNT_SAT_ID] = { ...item };
                  } else {
                    resultado[item.ACCOUNT_SAT_ID].SaldoFinal += item.SaldoFinal || 0;
                    resultado[item.ACCOUNT_SAT_ID].SaldoInicial += item.SaldoInicial || 0;
                    resultado[item.ACCOUNT_SAT_ID].TotalAbono += item.TotalAbono || 0;
                    resultado[item.ACCOUNT_SAT_ID].TotalCargo += item.TotalCargo || 0;
                  }
                });

                return Object.values(resultado);
              };

              const structuredDataSinDuplicados = agruparYSumar(structuredData2);
              // console.log(structuredDataSinDuplicados)
              for (const key of structuredDataSinDuplicados) {
                if (key.ACCOUNT_SAT_PARENT_ID !== 0) { // Es padre
                  this.totalSaldoInicial_ACCOUNT_SAT_PARENT += key.SaldoInicial || 0;
                  this.totalSaldoFinal_ACCOUNT_SAT_PARENT += key.SaldoFinal || 0;
                  this.totalAbonol_ACCOUNT_SAT_PARENT += key.TotalAbono || 0;
                  this.totalCargo_ACCOUNT_SAT_PARENT += key.TotalCargo || 0;
                }
              }

              // console.log(structuredDataSinDuplicados);
              this.dataSource = new MatTableDataSource(structuredDataSinDuplicados);
              this.dataSource.sort = this.sort;
              this.dataSource.paginator = this.paginator;

              this.gridMostrar(balanza);

              }
          this.gridMostrar(balanza);
        }
        if (this.dataBalanzaComprobacion.length <= 0) {
          $(".mat-row").remove(".mat-row");
        }
      }, (error) => {
        console.log(error as any);
      }
    );
  }

  structureData(data) {
    const result = [];
  
    // Agrupar los datos por RANGE_TYPE_ID
    const groupedByRangeTypeId = data.reduce((acc, item) => {
      const { RANGE_TYPE_ID, RANGE_TYPE_NAME } = item;
      if (!acc[RANGE_TYPE_ID]) {
        acc[RANGE_TYPE_ID] = { RANGE_TYPE_NAME, items: [], totalCargo: 0, totalAbono: 0, TotalSaldoInicial_RANGE_TYPE: 0, TotalSaldoFinal_RANGE_TYPE: 0 };
      }
      acc[RANGE_TYPE_ID].items.push(item);
      acc[RANGE_TYPE_ID].totalCargo += item.CARGO || 0; // Sumar CARGO si existe
      acc[RANGE_TYPE_ID].totalAbono += item.ABONO || 0; // Sumar ABONO si existe
      return acc;
    }, {});
  
    // Iterar sobre cada grupo de RANGE_TYPE_ID
    Object.keys(groupedByRangeTypeId).forEach(rangeTypeId => {
      const rangeType = groupedByRangeTypeId[rangeTypeId];
      const rangeTypeResult = [];
  
      // Agrupar los datos dentro de cada RANGE_TYPE_ID por RANGE_ACCOUNT_ID
      const groupedByRangeAccountId = rangeType.items.reduce((acc, item) => {
        const { RANGE_ACCOUNT_ID, RANGE_ACCOUNT_DESCRIPTION, CARGO, ABONO, SaldoInicial, SaldoFinal } = item;
        if (!acc[RANGE_ACCOUNT_ID]) {
          acc[RANGE_ACCOUNT_ID] = {
            RANGE_ACCOUNT_DESCRIPTION,
            items: [],
            totalCargo: 0,
            totalAbono: 0,
            totalSaldoInicial: 0,
            totalSaldoFinal: 0 // Inicializar totalSaldoFinal correctamente
          };
        }
        acc[RANGE_ACCOUNT_ID].items.push(item);
        acc[RANGE_ACCOUNT_ID].totalCargo += CARGO || 0; // Sumar CARGO si existe
        acc[RANGE_ACCOUNT_ID].totalAbono += ABONO || 0; // Sumar ABONO si existe
        if (item.NIVEL === 1) {
          acc[RANGE_ACCOUNT_ID].totalSaldoInicial += SaldoInicial || 0; // Sumar SaldoInicial si existe
          acc[RANGE_ACCOUNT_ID].totalSaldoFinal += SaldoFinal || 0; // Sumar SaldoFinal si existe
        }
        return acc;
      }, {});
  
      // Agregar los RANGE_ACCOUNT al resultado y sumar los saldos iniciales al RANGE_TYPE
      Object.keys(groupedByRangeAccountId).forEach(rangeAccountId => {
        const rangeAccount = groupedByRangeAccountId[rangeAccountId];
        const rangeAccountResult = [];
  
        // Agregar las filas de datos regulares debajo del RANGE_ACCOUNT si hay datos
        if (rangeAccount.items.length > 0) {
          rangeAccountResult.push(...rangeAccount.items);
        }
  
        const rangeAccountItem = {
          RANGE_ACCOUNT_ID: parseInt(rangeAccountId),
          type: 'RANGE_ACCOUNT',
          name: rangeAccount.RANGE_ACCOUNT_DESCRIPTION,
          TotalCargo: rangeAccount.totalCargo,
          TotalAbono: rangeAccount.totalAbono,
          TotalSaldoInicial: rangeAccount.totalSaldoInicial,
          TotalSaldoFinal: rangeAccount.totalSaldoFinal,
          NIVEL: 0,
          children: rangeAccountResult // Agregar los hijos como una propiedad "children"
        };
  
        rangeTypeResult.push(rangeAccountItem);
  
        // Sumar al saldo inicial y final del RANGE_TYPE
        if (rangeAccount.totalSaldoInicial) {
          rangeType.TotalSaldoInicial_RANGE_TYPE += rangeAccount.totalSaldoInicial;
        }
  
        if (rangeAccount.totalSaldoFinal) {
          rangeType.TotalSaldoFinal_RANGE_TYPE += rangeAccount.totalSaldoFinal;
        }
  
      });
  
      // Agregar una fila para el RANGE_TYPE con sumatorias
      const rangeTypeItem = {
        RANGE_TYPE_ID_index: parseInt(rangeTypeId),
        RANGE_TYPE_ID: parseInt(rangeTypeId),
        type: 'RANGE_TYPE',
        name: rangeType.RANGE_TYPE_NAME,
        TotalCargo: rangeType.totalCargo,
        TotalAbono: rangeType.totalAbono,
        TotalSaldoInicial_RANGE_TYPE: rangeType.TotalSaldoInicial_RANGE_TYPE,
        TotalSaldoFinal_RANGE_TYPE: rangeType.TotalSaldoFinal_RANGE_TYPE,
        NIVEL: 0,
        children: rangeTypeResult // Agregar los hijos como una propiedad "children"
      };
  
      result.push(rangeTypeItem);
    });
  
    // Agregar la fila TOTAL al final del resultado
    const totalItem = {
      type: 'TOTAL',
      NIVEL: 0
    };
    result.push(totalItem);
  
    // Convertir la estructura en un solo nivel
    function flattenStructure(items) {
      return items.reduce((acc, item) => {
        acc.push(item);
        if (item.children) {
          acc.push(...flattenStructure(item.children));
          delete item.children;
        }
        return acc;
      }, []);
    }
  
    return flattenStructure(result);
  }
  

  structureData2(data) {
    const result = [];
    // Procesar los datos y agregar filas al resultado
    data.forEach(item => {
      // Asegurarse de que NUMBERSAT esté definido
      if (item.NUMBERSAT === undefined) {
          item.NUMBERSAT = ''; 
      }
      result.push(item);
    });

    // Agregar la fila ACCOUNTTOTAL al final del resultado
    const accountItemTotal = {
        type: 'TOTAL2'
    };
    result.push(accountItemTotal);
   // console.log(result);
    return result;
  }

  gridMostrar(balanzaID: any) {
    if (balanzaID == 0) {
      this.displayedColumns = ['NUMEROCUENTA', 'NOMBRE', 'SALDOINICIAL', 'CARGO', 'ABONO', 'SALDOFINAL', 'NATURALEZA'];
    } else {
      this.displayedColumns = ['CODIGOSAT', 'NOMBRESAT', 'SALDOINICIAL', 'CARGOElectronico', 'ABONOElectronico', 'SALDOFINAL'];
    }
  }

  exportarXML() {
    const dialogRef = this.dialog.open(BalanzaComprobacionXMLComponent, {
      disableClose: true, 
      width:'30%', 
      panelClass: 'full-width-dialog',
      data: {}
     });
     this.dataService.dialogRef = dialogRef; 
     this.dataService.dialogRef = dialogRef;
     dialogRef.afterClosed().subscribe((result) => {
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/Contabilidad/balanzaComprobacion/consultar/balanzaComprobacion-consultar.component.ts